import { ReactElement } from 'react'
import { FormattedMessage, useIntl } from 'react-intl'
import { InputCurrency } from 'components/InputCurrency'
import { Column } from 'components/v2/Column'
import { Label } from 'components/v2/Label'
import Modal from 'components/v2/Modal'
import { Select } from 'components/v2/Select'
import { Formik } from 'formik'
import { Row } from 'components/v2/Row'
import { Button } from 'components/v2/Button'
import { getUnprocessableErrors } from '@10xlabs/utils'
import { ErrorMessage } from 'components/v2/ErrorMessage'
import { IDepositKreditsFormValues } from 'features/Kredits/types'
import { schema } from './schema'

import { IDepositKreditsFormProps } from '../../views/Index/MultipleActions'
import { GTKreditAccountType } from 'gql/types.generated'

export const DepositKreditsForm = ({ onSubmit, onCancel, loading, error }: IDepositKreditsFormProps): ReactElement => {
  const intl = useIntl()

  const initialValues: IDepositKreditsFormValues = {
    amount: '',
    creditType: ''
  }

  return (
    <Formik
      validationSchema={schema(intl)}
      initialValues={initialValues}
      onSubmit={(values): void => {
        onSubmit(values)
      }}
    >
      {(props): ReactElement => (
        <form onSubmit={props.handleSubmit}>
          <Modal.Content>
            <Row>
              <Column>
                <Label>
                  <FormattedMessage
                    id="kredits.multipleActions.depositKreditsModal.creditsType"
                    defaultMessage="Type of credit"
                  />
                </Label>
                <Select
                  id="creditType"
                  value={props.values.creditType}
                  onChange={props.handleChange}
                  onBlur={props.handleBlur}
                  touched={props.touched.creditType}
                  errors={props.errors.creditType}
                >
                  <option value="">
                    <FormattedMessage
                      id="kredits.multipleActions.depositKreditsModal.selectType"
                      defaultMessage="Select type"
                    />
                  </option>
                  <option value={GTKreditAccountType.Corporate}>
                    <FormattedMessage
                      id="kredits.multipleActions.depositKreditsModal.corporate"
                      defaultMessage="Corporate"
                    />
                  </option>
                  <option value={GTKreditAccountType.Bonus}>
                    <FormattedMessage
                      id="kredits.multipleActions.depositKreditsModal.bonus"
                      defaultMessage="Bonus Credits"
                    />
                  </option>
                </Select>
              </Column>
            </Row>
            <Row>
              <Column>
                <Label>
                  <FormattedMessage id="kredits.multipleActions.depositKreditsModal.amount" defaultMessage="Amount" />
                </Label>
                <InputCurrency
                  id="amount"
                  value={props.values.amount}
                  placeholder="$0.00"
                  onChange={(value): void => {
                    props.setFieldValue('amount', value)
                  }}
                  onBlur={props.handleBlur}
                  touched={props.touched.amount}
                  errors={props.errors.amount}
                  hideSuffix
                />
              </Column>
            </Row>
          </Modal.Content>
          <Modal.Footer>
            {error && (
              <Modal.ErrorMessage>
                <ErrorMessage errors={getUnprocessableErrors(error)}>
                  <FormattedMessage
                    id="kredits.multipleActions.depositKreditsModal.error"
                    defaultMessage="An error has occurred "
                  />
                </ErrorMessage>
              </Modal.ErrorMessage>
            )}
            <Modal.Actions>
              <Button kind="cancel" type="button" onClick={onCancel}>
                <FormattedMessage id="kredits.multipleActions.depositKreditsModal.cancel" defaultMessage="Back" />
              </Button>
              <Button type="submit" disabled={loading || !props.dirty} loading={loading}>
                <FormattedMessage id="kredits.multipleActions.depositKreditsModal.submit" defaultMessage="Add" />
              </Button>
            </Modal.Actions>
          </Modal.Footer>
        </form>
      )}
    </Formik>
  )
}
